import { ContentRestrictionBase } from "abweb/dto/generated/ds/ContentRestrictionBase";
export class ContentRestriction extends ContentRestrictionBase {
  static createContentRestriction(value) {
    const retVal = new ContentRestriction();
    retVal.initContentRestriction(value);
    return retVal;
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=ContentRestriction.js.map
